import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';
import { useSelector } from 'react-redux';
import { selectBusinessTeamsForDropdown } from 'state/BusinessTeams/businessTeamsSlice';

interface BusinessUnitFormProps {
  onChange: (value: string) => void;
}

const BusinessUnitForm = ({ onChange }: BusinessUnitFormProps) => {
  const businessTeamsOptions = useSelector(selectBusinessTeamsForDropdown);

  return (
    <FormItem
      label={intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.BUSINESS_UNIT_FORM.LABEL'
      )}
    >
      <Dropdown
        options={businessTeamsOptions}
        onChange={(option) => onChange(option.value)}
        triggerProps={{
          placeholder: intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.BUSINESS_UNIT_FORM.PLACEHOLDER'
          ),
        }}
      />
    </FormItem>
  );
};

export default BusinessUnitForm;
